var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from "react";
import cn from "classnames";
/**
 * The `MediaOverlay` component is used to create an overlay over specific media
 * items within the `MediaContainer` component. You will need to apply most of
 * your own styles as this is really just used for positioning.
 */
export var MediaOverlay = forwardRef(function MediaOverlay(_a, ref) {
    var className = _a.className, children = _a.children, _b = _a.position, position = _b === void 0 ? "bottom" : _b, props = __rest(_a, ["className", "children", "position"]);
    return (React.createElement("div", __assign({}, props, { ref: ref, className: cn("rmd-media-overlay rmd-media-overlay--" + position, className) }), children));
});
/* istanbul ignore next */
if (process.env.NODE_ENV !== "production") {
    try {
        var PropTypes = require("prop-types");
        MediaOverlay.propTypes = {
            className: PropTypes.string,
            children: PropTypes.node,
            position: PropTypes.oneOf([
                "top",
                "right",
                "bottom",
                "left",
                "center",
                "middle",
                "absolute-center",
            ]),
        };
    }
    catch (e) { }
}
//# sourceMappingURL=MediaOverlay.js.map